import { computed, inject, Injectable } from '@angular/core';
import {
  RsOverviewServerSideStateManager
} from '@rs-shared-lib/abstract-classes/rs-overview-state/rs-overview-server-side-state-manager';
import {
  RsPersistOverviewState
} from '@rs-shared-lib/abstract-classes/rs-overview-state/persistency/rs-persist-overview-state.decorator';
import { rsCountFilters } from '@rs-shared-lib/utils/count-filters/count-filters';
import { GetOutboundInvoicesRequestParams, InvoiceItemResponse, InvoicesService } from '@api-client/mobipay';
import { DEFAULT_PAGE_SIZE_OPTIONS } from '@app/shared/constants';

@RsPersistOverviewState('InvoicesOutboundState')
@Injectable({ providedIn: 'root' })
export class OutboundInvoicesStateService extends RsOverviewServerSideStateManager<
  InvoiceItemResponse,
  GetOutboundInvoicesRequestParams
> {
  public readonly filterCount = computed(() =>
    rsCountFilters(this.filters(), [
      'source',
      'validation',
      'type',
      ['sendDateFrom', 'sendDateTo'],
      ['invoiceDateFrom', 'invoiceDateTo'],
      ['deliveryDateFrom', 'deliveryDateTo'],
      'sellerSite',
      'buyerCompany',
      'status',
    ]),
  );

  private readonly invoicesService = inject(InvoicesService);
  constructor() {
    super({
      serviceMethod: (params) =>
        this.invoicesService.getOutboundInvoices(params as GetOutboundInvoicesRequestParams, 'response'),
      initialPagination: { pageIndex: 0, pageSize: 15 },
      config: {
        pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
      },
    });
  }
}

